import React ,{useContext}from "react";
import AddAdminTransporter from "./addAdminTransporter";
import AdminTransporterTable from "./AdminTransporterTable";
import Pagination from "../../Pagination";
import AdminContext from "./AdminDashContext";
import { Link } from "react-router-dom";

export default function AdminTransporters(){
  const {allTransporters,addAdminTransporter,updateAdminTransporter,deleteAdminTransporter,editTransporter, transporterToEdit,  setTransporterToEdit,paginate, currentPage,postsPerPage,newTransportersData}=useContext(AdminContext)
  const shouldPaginate=allTransporters.length>4
  const displayedTransporters=shouldPaginate?newTransportersData:allTransporters
    return(
        <div className="mb-16">
            <h4>TRANSPORTERS</h4>            
            <Link to="/adminDash/communicate/transport_owners">transportOwners</Link>
            <AddAdminTransporter onAdd={addAdminTransporter} onEdit={updateAdminTransporter} transporterToEdit={transporterToEdit} setTransporterToEdit={setTransporterToEdit}/>
            <AdminTransporterTable onDelete={deleteAdminTransporter} TransporterData={displayedTransporters} onEdit={editTransporter}/>
           {shouldPaginate? <Pagination postsPerPage={postsPerPage} totalPosts={allTransporters.length} currentPage={currentPage} paginate={paginate}/>:null}
        </div>
    )
}